import { AddDateBtn, AddDateWrapper, Btn, DatesWrapper } from "./paragraph.styles";
import {ReactComponent as PlusSvg} from "@assets/icons/plus.svg";
import DateSelector from "components/atoms/DateSelector/dateSelector";
import { CloseOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useParagraphEditorDataContext } from "contexts/ParagraphEditorContext";
import { useTranslation } from "react-i18next";
import Dropdown from "components/atoms/Dropdown/dropdown";
import { DDButton, DDContent } from "../../display/Chapter/сhapter.styles";

export default function ParagraphDates() {
  const { t } = useTranslation();
  const {draftParagraph, updateDraftParagraph} = useParagraphEditorDataContext();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hasFromDate, setHasFromDate] = useState<boolean>(!!draftParagraph.date_from_day || !!draftParagraph.date_from_month || !!draftParagraph.date_from_year);
  const [hasToDate, setHasToDate] = useState<boolean>(!!draftParagraph.date_to_day || !!draftParagraph.date_to_month || !!draftParagraph.date_to_year);

  const updateFromDate = (d: number | null, m: number | null, y: number | null) => {
    updateDraftParagraph({
      date_from_day: d,
      date_from_month: m,
      date_from_year: y,
    });
  };

  const updateToDate = (d: number | null, m: number | null, y: number | null) => {
    updateDraftParagraph({
      date_to_day: d,
      date_to_month: m,
      date_to_year: y,
    });
  };

  const clearDates = () => {
    updateFromDate(null, null, null);
    updateToDate(null, null, null);
    setHasFromDate(false);
    setHasToDate(false);
  }

  const addDates = (period?: boolean) => {
    setHasFromDate(true);
    if (period) setHasToDate(true);
    setDropdownOpen(false);
  }

  const hasNoDates = !hasFromDate && !hasToDate;

  return (
    <DatesWrapper>
      {hasNoDates && (
        <AddDateWrapper>
          <AddDateBtn onClick={() => setDropdownOpen(p => !p)}>
            {t('wall.addDate')} <PlusSvg />
          </AddDateBtn>
          <Dropdown position="left" isOpen={dropdownOpen} onClose={() => setDropdownOpen(false)}>
            <DDContent>
              <DDButton onClick={() => addDates()}>{t('wall.fixedDate')}</DDButton>
              <DDButton onClick={() => addDates(true)}>
                {t('wall.period')}
              </DDButton>
            </DDContent>
          </Dropdown>
        </AddDateWrapper>
      )}
      {hasFromDate && (
        <DateSelector
          initialDay={draftParagraph.date_from_day}
          initialMonth={draftParagraph.date_from_month}
          initialYear={draftParagraph.date_from_year}
          onChange={updateFromDate}
        />
      )}
      {hasToDate && <div>{" -> "}</div>}
      {hasToDate && (
        <DateSelector
          initialDay={draftParagraph.date_to_day}
          initialMonth={draftParagraph.date_to_month}
          initialYear={draftParagraph.date_to_year}
          onChange={updateToDate}
        />
      )}
      {hasFromDate && (
        <Btn onClick={clearDates}>
          <CloseOutlined />
        </Btn>
      )}
    </DatesWrapper>
  );
};
